export interface AdditionalClassSelectOption {
  id: string
  label?: string
  labelKey?: string
}

export enum SchoolClassOptionTypes {
  All = 'all-classes',
  My = 'my-classes',
}
export const AllClassesOption: AdditionalClassSelectOption = {
  id: SchoolClassOptionTypes.All,
  labelKey: 'schoolClass.all',
}
export const MyClassesOption: AdditionalClassSelectOption = {
  id: SchoolClassOptionTypes.My,
  labelKey: 'schoolClass.my',
}
